import { Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import useCheckUpdated from '../../../hooks/useCheckUpdated';
import { useSelectSearchProps } from '../hooks';
import { getRegionsByCountryName } from '../utils/locationData';

const RegionField = ({ value, related, onChange, ...props }) => {
  const options = useMemo(
    () => (related ? getRegionsByCountryName(related) : []),
    [related]
  );
  
  useCheckUpdated(() => {
    onChange && onChange();
  }, related);
  
  const _props = useSelectSearchProps(options, value);
  
  return (
    <Select
      disabled={!related}
      allowClear
      onChange={onChange}
      value={value}
      {..._props}
      {...props}
    />
  );
};

RegionField.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  related: PropTypes.string,
  props: PropTypes.object,
};

export default RegionField;
